<template>
  <main class="customer-service">
    <van-nav-bar
      :title="$t('shop.customerService')"
      left-arrow
      @click-left="$router.back()"
    />
    <section class="customer-service__status">
      <van-loading
        v-if="loading"
        vertical
        :text="$t('utils.loading')"
      />
      <van-empty
        v-else
        :description="$t('item.noData')"
      />
    </section>
  </main>
</template>

<script>
import Fetch from '../../utils/fetch'

export default {
  name: 'Kefu2',
  data() {
    return {
      loading: true
    }
  },
  created() {
    this.$parent.footer('user', true)
  },
  mounted() {
    this.openCustomerService()
  },
  methods: {
    openCustomerService() {
      Fetch('/index/webconfig')
        .then((res) => {
          const url = this.normalizeCustomerUrl(
            res && res.data ? res.data.kefu_link : ''
          )
          if (url) {
            window.location.assign(url)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    normalizeCustomerUrl(value) {
      if (typeof value !== 'string' || !value.trim()) {
        return ''
      }
      try {
        const url = new URL(value.trim())
        return ['http:', 'https:'].indexOf(url.protocol) !== -1 ? url.href : ''
      } catch (e) {
        return ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.customer-service {
  min-height: 100vh;
  background: #fff;
}

.customer-service__status {
  min-height: calc(100vh - 50px);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
